var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 7L7.6875 7.71875L2.6875 12.7188L2 13.4375L0.5625 12L1.28125 11.3125L5.5625 7L1.28125 2.71875L0.5625 2L2 0.59375L2.6875 1.3125L7.6875 6.3125L8.40625 7Z",
    fill: "#377199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectArrow);
export default __webpack_public_path__ + "static/media/project_arrow.92f65090c6a070843254c8e67b7aa7c5.svg";
export { ForwardRef as ReactComponent };